module.exports = __webpack_public_path__ + "images/user-image.2f62f30.png";